import Serializer from 'umg-ember-backend/serializers/application';

export default class StorySerializer extends Serializer {
  attrs = {
    ownedByChannel: 'ownedByChannelId',
  };
}
